import React from 'react';
import FooterLogo from '../FooterLogo';
import CopyRight from '../CopyRight';
import RightSection from './RightSection';
import DeleteAccount from './DeleteAccount';

function DeleteContent() {
  return (
    <section className="login-page brain-pointer-none privacy-policy-page">
      <div className="container-fluid pd-80">
        <div className="row align-items-center flex-column flex-md-row-reverse flex-lg-row-reverse">
          <div className="col-xl-3 col-lg-3 col-md-12 col-12 d-inline-block align-self-end order-3">
            <FooterLogo />
          </div>
          <div className="col-xl-5 col-lg-5 col-md-12 col-12 order-2">
            <DeleteAccount />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 col-12 order-1 d-none d-lg-block">
            <RightSection />
          </div>
        </div>
        <CopyRight />
      </div>
    </section>
  );
}

export default DeleteContent;